<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_actualQty') || '出货数量'"
            prop="actualQty"
          >
            <el-input-number
              v-model="formData.actualQty"
              style="width: 100%"
              controls-position="right"
              :min="0"
              :step="1"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_rejectReason') || '修改原因'"
            prop="rejectReason"
          >
            <el-input
              v-model="formData.rejectReason"
              type="textarea"
              :rows="8"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { amzReplenishmentDetailCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      rules: {
        actualQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'change',
          },
        ],
        rejectReason: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentDetailCode) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailDetailApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      const { body } = res || {}
      const { amzReplenishmentDetailCode, actualQty, rejectReason } = body || {}
      this.formData = { amzReplenishmentDetailCode, actualQty, rejectReason }
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyOutRejectApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_reject_failed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_rejected_successfully'),
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.rejected()
        })
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
